//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { StudentStatus } from './Enums';

export class StudentSearchOptions extends ItemBase {
    IDs: string[] = [];
    SearchText: string | null = null;
    FirstName: string | null = null;
    LastName: string | null = null;
    EmailAddress: string | null = null;
    MaxLastEventDate: string | null = null;
    MinNextEventDate: string | null = null;
    Statuses: StudentStatus[] = [];
    TeacherIDs: string[] = [];
    FamilyIDs: string[] = [];
    TagIDs: string[] = [];

    constructor(initializer?: Partial<StudentSearchOptions>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "StudentSearchOptions";
}
